import { makeStyles } from '@material-ui/core/styles';
import { EntitySoc2Filter, CustomFilters } from '../CustomFilters';
import { useEntityList } from '@backstage/plugin-catalog-react';
import { Select, MenuItem, FormControl } from '@material-ui/core';

/** @public */
export type CatalogReactEntitySoc2PickerClassKey = 'input';

const useStyles = makeStyles(
  theme => ({
    input: {
      backgroundColor: theme.palette.background.paper,
    },
  }),
  { name: 'CatalogReactEntitySoc2Picker' },
);

/** @public */
export const EntitySoc2Picker = () => {
  const classes = useStyles();

  const {
    filters: { soc2 },
    updateFilters,
  } = useEntityList<CustomFilters>();

  function onChange(event: React.ChangeEvent<{ value: unknown }>) {
    const value = event.target.value as string;
    updateFilters({
      soc2: value ? new EntitySoc2Filter([value]) : undefined,
    });
  }

  const selectedValue = soc2?.values?.[0] || '';

  return (
    <div>
      <label
        htmlFor="soc2-picker"
        style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px' }}
      >
        SOC2
      </label>
      <FormControl
        id="soc2-picker"
        variant="outlined"
        size="small"
        fullWidth
        className={classes.input}
      >
        <Select value={selectedValue} onChange={onChange}>
          <MenuItem value="">
            <em>All</em>
          </MenuItem>
          <MenuItem value="true">Yes</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};
